import React from 'react';

// import { PersonalisationProgressBar } from '../PersonalisationProgressBar';

import styles from './gwp-header.module.css';

/**
 * GwpHeader component displays the header for the GWP journey, including title, reset, and close actions.
 *
 * @param {Object} props - Component props
 * @param {string} props.title - The header title
 * @param {string} props.resetText - The reset button text
 * @param {function} props.onClose - Callback for closing the modal
 * @param {function} props.onReset - Callback for resetting the journey
 * @param {boolean} props.isResetting - Whether the header is in resetting state
 * @returns {import('react').JSX.Element}
 */
export function GwpHeader({ title, resetText, onReset }) {
  return (
    <div className={styles['personalisation__header']}>
      <div className={styles['personalisation__header-content']}>
        {title && <h2 className="heading-2xl">{title}</h2>}
        <div className={styles['personalisation__header-actions']}>
          {resetText && (
            <button
              className={'body-sm button-reset ' + styles['personalisation__header-reset']}
              onClick={(e) => onReset(e)}
            >
              {resetText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
